import { FETCH_D2C_DATA, FETCH_D2C_REQUEST, FETCH_D2C_ERROR, RESET_D2C_VIEW_DATA, FETCH_D2C_EVENT } from './d2cTypes';

const initialState = {
  loading: false,
  requestLoading: false,
  d2cData: [],
  error: '',
  error_msg: '',
  viewType: 'nonskan' // Default view
};

const d2cReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_D2C_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_D2C_EVENT:
      return {
        ...state,
        loading: true
      };

    case RESET_D2C_VIEW_DATA:
      return {
        ...state,
        d2cData: []
      };

    case FETCH_D2C_DATA:
      return {
        ...state,
        loading: false,
        d2cData: action.payload
      };

    case FETCH_D2C_ERROR:
      return {
        ...state,
        loading: false,
        d2cData: [],
        error_msg: 'Sorry no data found',
        error: action.payload
      };

    default:
      return state;
  }
};

export default d2cReducer;
